<div class="ui-grid ui-grid-responsive ui-fluid">
    <user-grid-component></user-grid-component>
</div>
